<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12" v-if="user.status === 203">
                <b-card :title="title" :sub-title="subtitle" class="text-center bg-none my-4" body-class="px-0">
                    <b-form>
                        <b-row align-h="center">
                            <b-col cols="12" align-self="center">
                                <img :src="'https://flagcdn.com/h40/' + (user.country ? user.country : '').toLowerCase() + '.png'"
                                    :srcset="'https://flagcdn.com/h80/' + (user.country ? user.country : '').toLowerCase() + '.png 2x'"
                                    height="28" :alt="user.country" class="border-flag">
                                <i class="material-icons mx-2 v-align">send</i>
                                <img :src="'https://flagcdn.com/h40/' + (form.country ? form.country : '').toLowerCase() + '.png'"
                                    :srcset="'https://flagcdn.com/h80/' + (form.country ? form.country : '').toLowerCase() + '.png 2x'"
                                    height="28" :alt="form.country" class="border-flag">
                            </b-col>
                        </b-row>
                        <b-progress max="100" height="2rem" class="my-4" show-progress animated variant="primary">
                            <b-progress-bar :value="progress">
                                <span><b style="font-size: 1rem;">{{ progress.toFixed(0) }} %</b></span>
                            </b-progress-bar>
                        </b-progress>
                        <b-row align-h="center" v-if="current_step === 1">
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.country + ':'">
                                    <b-form-select name="country" :options="countries" v-validate="'required:true'"
                                        :state="validateState('country')" :data-vv-as="(labels.country).toLowerCase()"
                                        :disabled="loading" aria-describedby="country-live-feedback"
                                        :value="form.country" v-model="form.country" class="form-control select-center"
                                        size="lg"></b-form-select>
                                    <b-form-invalid-feedback id="country-live-feedback">{{ veeErrors.first('country')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.payReceiver + ':'">
                                    <b-form-radio-group v-model="form.payReceiver" :options="payReceivers"
                                        v-validate="'required:true'" :state="validateState('payReceiver')"
                                        :data-vv-as="(labels.payReceiver).toLowerCase()" :disabled="loading"
                                        aria-describedby="payReceiver-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="payReceiver"
                                        buttons></b-form-radio-group>
                                    <b-form-invalid-feedback id="payReceiver-live-feedback"
                                        :state="validateState('payReceiver')">{{ veeErrors.first('payReceiver')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="labels.office + ':'" v-show="form.payReceiver === 'Cash'">
                                    <v-select :options="offices" v-model="officeSelected" :searchable="true"
                                        :disabled="loading" class="pb-1 h-auto"
                                        labelTitle="-- Por favor seleccione una oficina --"
                                        labelNotFound="La oficina no existe" labelSearchPlaceholder="Buscar Oficina"
                                        textProp="name" />
                                    <b-form-select v-show="false" name="office" :options="offices" :value="form.office"
                                        v-model="form.office" class="form-control select-center"
                                        v-validate="(form.payReceiver === 'Cash' ? 'required:true' : '')"
                                        :state="validateState('office')" :data-vv-as="(labels.office).toLowerCase()"
                                        :disabled="loading" aria-describedby="office-live-feedback" value-field="code"
                                        text-field="name">
                                    </b-form-select>
                                    <b-form-invalid-feedback id="office-live-feedback">{{ veeErrors.first('office')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group :label="labels.bank + ':'" v-show="form.payReceiver === 'Bank'">
                                    <v-select :options="banks" v-model="bankSelected" :searchable="true"
                                        :disabled="loading" class="pb-1 h-auto"
                                        labelTitle="-- Por favor seleccione un banco --"
                                        labelNotFound="El banco no existe" labelSearchPlaceholder="Buscar banco"
                                        textProp="name" />
                                    <b-form-select v-show="false" name="bank" :options="banks" :value="form.bank"
                                        v-model="form.bank" text-field="name" value-field="code"
                                        class="form-control select-center"
                                        v-validate="(form.payReceiver === 'Bank' ? 'required:true' : '')"
                                        :state="validateState('bank')" :data-vv-as="(labels.bank).toLowerCase()"
                                        :disabled="loading" aria-describedby="bank-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="bank-live-feedback">{{ veeErrors.first('bank')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Seleccione ' + labels.type + ':'">
                                    <b-form-radio-group v-model="form.type" :options="types"
                                        v-validate="'required:true'" :state="validateState('type')"
                                        :data-vv-as="(labels.type).toLowerCase()" :disabled="loading"
                                        aria-describedby="type-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="type"
                                        buttons></b-form-radio-group>
                                    <b-form-invalid-feedback id="type-live-feedback" :state="validateState('type')">{{
                                        veeErrors.first('type') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4 mb-0">
                                <b-form-group :label="'Ingrese ' + labels.value + ':'">
                                    <b-input-group>
                                        <template #prepend>
                                            <b-input-group-text class="m-0 px-4 btrr-0 bbrr-0"><b>{{ form.currency ===
                                                'PEN' ? 'S/.' : (form.currency === 'EUR' ? '€' : '$')
                                                    }}</b></b-input-group-text>
                                        </template>
                                        <currency-input v-model="form.value" name="value"
                                            v-validate="'required:true|min_value:' + min + '|max_value:' + max"
                                            :state="validateState('value')" aria-describedby="value-live-feedback"
                                            :data-vv-as="(labels.value).toLowerCase()" :disabled="loading"
                                            :precision="currency_precision"
                                            class="text-right text-sm-center form-control form-control-lg"
                                            style="padding: 0.5rem 1rem; background-image: none;"></currency-input>
                                        <template #append>
                                            <b-dropdown :text="form.currency" variant="default" right
                                                class="m-0 btlr-0 bblr-0" toggle-class="px-sm-4">
                                                <template v-for="item in currencies">
                                                    <b-dropdown-item
                                                        :key="item.code"
                                                        @click="form.currency = item.code"
                                                        v-if="(form.type === 'S' && item.country === form.local) || (form.type === 'R' && item.country === form.country && item.enabled)">
                                                        {{ item.code + ' - ' + item.name }}
                                                    </b-dropdown-item>
                                                </template>
                                            </b-dropdown>
                                        </template>
                                    </b-input-group>
                                    <b-form-invalid-feedback id="value-live-feedback">{{ veeErrors.first('value')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="10" md="6" lg="5" align-self="start" class="mt-md-4">
                                <b-form-group :label="'Seleccione ' + labels.convert + ':'" v-show="quotes[0]">
                                    <b-form-radio-group v-model="form.convert" :options="quotes"
                                        v-validate="{ required: true, is_not: 0 }" :state="validateState('convert')"
                                        :data-vv-as="(labels.convert).toLowerCase()" :disabled="loading"
                                        aria-describedby="convert-live-feedback" button-variant="outline-primary"
                                        class="btn-block align-baseline" size="lg" name="convert"
                                        buttons></b-form-radio-group>
                                    <b-form-invalid-feedback id="convert-live-feedback"
                                        :state="validateState('convert')">{{
                                            veeErrors.first('convert') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 2">
                            <b-col cols="12" md="10" align-self="start">
                                <b-button variant="outline-primary" class="btn-r5 shadow" @click="clearData">
                                    <i class="material-icons">add</i>
                                    <span>Agregar<br>Nuevo</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.favorite>
                                    <i class="material-icons">star</i>
                                    <span>Seleccione<br>Favorito</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.qrReader>
                                    <i class="material-icons">qr_code_scanner</i>
                                    <span>Escanear<br>QR</span>
                                </b-button>
                                <b-button variant="outline-primary" class="btn-r5 shadow" v-b-modal.manualCode>
                                    <i class="material-icons">dialpad</i>
                                    <span>Agregar<br>Código</span>
                                </b-button>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name + ':'">
                                    <b-form-input name="name" v-model="form.name" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:40'"
                                        :state="validateState('name')" :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading" aria-describedby="name-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{ veeErrors.first('name')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.lname + ':'">
                                    <b-form-input name="lname" v-model="form.lname" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')" :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading" aria-describedby="lname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{ veeErrors.first('lname')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mname + ':'">
                                    <b-form-input name="mname" v-model="form.mname" type="text" class="text-center"
                                        v-validate="'alpha_spaces|max:19'" :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()" :disabled="loading"
                                        aria-describedby="mname-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{ veeErrors.first('mname')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.td + ':'">
                                    <b-form-select name="td" :options="td" :value="form.td" v-model="form.td"
                                        class="form-control select-center" v-validate="'required:true'"
                                        :state="validateState('td')" :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading" aria-describedby="td-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="td-live-feedback">{{ veeErrors.first('td')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.nd + ':'">
                                    <b-form-input name="nd" v-model="form.nd" :type="typeND ? 'text' : 'number'"
                                        :inputmode="typeND ? 'text' : 'numeric'" class="text-center"
                                        v-validate="'required:true' + validateND" :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()" :disabled="loading"
                                        aria-describedby="nd-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{ veeErrors.first('nd')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.issuedBy + ':'">
                                    <b-form-select name="issuedBy" :options="countries_list" :value="form.issuedBy"
                                        v-model="form.issuedBy" v-validate="'required:true'"
                                        :state="validateState('issuedBy')" :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading" aria-describedby="issuedBy-live-feedback"
                                        class="form-control select-center" value-field="iso2"
                                        text-field="name"></b-form-select>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.email + ':'">
                                    <b-form-input name="email" v-model="form.email" type="email" class="text-center"
                                        v-validate="'required:true|email'" :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()" :disabled="loading"
                                        aria-describedby="email-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.mobile + ':'">
                                    <b-form-input name="mobile" v-model="form.mobile" type="tel" inputmode="tel"
                                        class="text-center" v-validate="'required:true|numeric' + vMobile"
                                        :state="validateState('mobile')" :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading" aria-describedby="mobile-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{ veeErrors.first('mobile')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <b-form-group :label="labels.tc + ':'">
                                    <b-form-select name="tc" :options="tc" :value="form.tc" v-model="form.tc"
                                        class="form-control select-center" v-validate="'required:true'"
                                        :state="validateState('tc')" :data-vv-as="(labels.tc).toLowerCase()"
                                        :disabled="loading" aria-describedby="tc-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="tc-live-feedback">{{ veeErrors.first('tc')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.payReceiver === 'Bank'">
                                <b-form-group :label="labels.nc + ':'">
                                    <b-form-input name="nc" v-model="form.nc" :type="typeNC ? 'text' : 'number'"
                                        :inputmode="typeNC ? 'text' : 'numeric'" class="text-center"
                                        v-validate="'required:true' + validateNC" :state="validateState('nc')"
                                        :data-vv-as="(labels.nc).toLowerCase()" :disabled="loading"
                                        aria-describedby="nc-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nc-live-feedback">{{ veeErrors.first('nc')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'AR'">
                                <b-form-group :label="labels.cbu + ':'">
                                    <b-form-input name="cbu" v-model="form.cbu" type="number" inputmode="numeric"
                                        class="text-center"
                                        v-validate="'required:true|digits:22|cbu|is_not:' + '0'.repeat(22)"
                                        :state="validateState('cbu')" :data-vv-as="(labels.cbu).toLowerCase()"
                                        :disabled="loading" aria-describedby="cbu-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="cbu-live-feedback">{{ veeErrors.first('cbu')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'BR'">
                                <b-form-group :label="labels.nab + ':'">
                                    <b-form-input name="nab" v-model="form.nab" type="number" inputmode="numeric"
                                        class="text-center" v-validate="'required:true'" :state="validateState('nab')"
                                        :data-vv-as="(labels.nab).toLowerCase()" :disabled="loading"
                                        aria-describedby="nab-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="nab-live-feedback">{{ veeErrors.first('nab')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start"
                                v-if="form.payReceiver === 'Bank' && form.country === 'BR'">
                                <b-form-group :label="labels.cpf + ':'">
                                    <b-form-input name="cpf" v-model="form.cpf" type="number" inputmode="numeric"
                                        class="text-center" v-validate="'required:true|digits:11'"
                                        :state="validateState('cpf')" :data-vv-as="(labels.cpf).toLowerCase()"
                                        :disabled="loading" aria-describedby="cpf-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="cpf-live-feedback">{{ veeErrors.first('cpf')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.address + ':'">
                                    <b-form-input name="address" v-model="form.address" type="text" class="text-center"
                                        v-validate="'required:true|min:3|max:70'" :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()" :disabled="loading"
                                        aria-describedby="address-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{ veeErrors.first('address')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.district + ':'">
                                    <b-form-input name="district" v-model="form.district" type="text"
                                        class="text-center" v-validate="'required:true|min:3|max:35'"
                                        :state="validateState('district')" :data-vv-as="(labels.district).toLowerCase()"
                                        :disabled="loading" aria-describedby="district-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="district-live-feedback">{{ veeErrors.first('district')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city + ':'">
                                    <b-form-input name="city" v-model="form.city" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('city')" :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading" aria-describedby="city-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{ veeErrors.first('city')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state + ':'">
                                    <b-form-input name="state" v-model="form.state" type="text" class="text-center"
                                        v-validate="'required:true|alpha_spaces|min:3|max:35'"
                                        :state="validateState('state')" :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading" aria-describedby="state-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{ veeErrors.first('state')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-form-group label="¿Deseas agregarlo a favoritos?">
                                    <b-form-checkbox v-model="form.favorite" name="check-button" button
                                        :button-variant="(form.favorite ? '' : 'outline-') + 'default px-5 py-2 rounded-pill'">
                                        <b-icon :icon="'star' + (form.favorite ? '-fill' : '')" class="pr-1"></b-icon>
                                        <span style="vertical-align: bottom;">{{ form.favorite ? 'Agregado' : 'Agregar'
                                        }}</span>
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>

                            <!-- Modal Search Receiver -->
                            <b-modal id="favorite" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Buscar Beneficiario" tabindex="-1" role="dialog" size="lg" aria-hidden="true">
                                <b-form id="formFavorites" @submit.stop.prevent="getData('favorite')">
                                    <b-row align-h="center">
                                        <b-col cols="12" sm="10" md="9" class="mb-3" align-self="start">
                                            <b-form-group :label="labels.favorite + ':'">
                                                <v-select :options="accounts" v-model="accountSelected"
                                                    :searchable="true" :disabled="loadingFavs"
                                                    labelTitle="-- Por favor seleccione un beneficiario --"
                                                    labelNotFound="El destinatario no existe"
                                                    labelSearchPlaceholder="Buscar Destinatario"
                                                    :textProp="form.payReceiver === 'Cash' ? 'ftext' : 'text'" />
                                                <b-form-select v-show="false" name="favorite" :options="accounts"
                                                    :value="form.accountID" v-model="form.accountID"
                                                    class="form-control select-center"
                                                    v-validate="'required:true|excluded:0'"
                                                    :state="validateState('favorite')"
                                                    :data-vv-as="(labels.favorite).toLowerCase()"
                                                    :disabled="loadingFavs" aria-describedby="favorite-live-feedback"
                                                    value-field="id"
                                                    :text-field="form.payReceiver === 'Cash' ? 'ftext' : 'text'"></b-form-select>
                                                <b-form-invalid-feedback id="favorite-live-feedback">{{
                                                    veeErrors.first('favorite')
                                                    }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" align-self="center">
                                            <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                                                form="formFavorites" :disabled="loadingFavs">
                                                <b-spinner small type="grow" v-if="loadingFavs"></b-spinner>
                                                <b-icon icon="check-all" aria-hidden="true" v-else></b-icon>
                                                &nbsp;&nbsp;<span>{{ loadingFavs ? 'Aplicando...' : 'Aplicar' }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-modal>

                            <!-- Modal QR Reader -->
                            <b-modal id="qrReader" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Lector de QR" tabindex="-1" role="dialog" aria-hidden="true">
                                <b-row align-h="center">
                                    <b-col cols="12" align-self="center">
                                        <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                                            <div v-if="qrReaderLoading" class="loading-indicator m-3">
                                                Iniciando Cámara ...
                                            </div>
                                            <div v-if="validationSuccess" class="validation-success">
                                                <img :src="checkIcon" alt="Checkmark" />
                                                El QR ha sido verificado exitosamente!
                                            </div>
                                            <div v-if="validationFailure" class="validation-failure">
                                                <img :src="uncheckIcon" alt="Xmark" />
                                                La verificación del QR ha fallado!
                                            </div>
                                            <div v-if="validationPending" class="validation-pending">
                                                <img :src="loadIcon" alt="Synchronization" />
                                                Verificación de QR en progreso...
                                            </div>
                                        </qrcode-stream>
                                        <b-form-input v-show="false" name="qrReader" v-model="result" type="text"
                                            class="text-center" v-validate="'required:true'"
                                            :state="validateState('qrReader')"
                                            :data-vv-as="(labels.clientCode).toLowerCase()" :disabled="loadingFavs"
                                            aria-describedby="qrReader-live-feedback"></b-form-input>
                                        <b-form-invalid-feedback id="qrReader-live-feedback">{{
                                            veeErrors.first('qrReader')
                                            }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                            </b-modal>

                            <!-- Modal Manual Insert -->
                            <b-modal id="manualCode" centered no-fade header-class="text-center"
                                header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                title="Ingresar Código de Forma Manual" tabindex="-1" role="dialog" size="lg"
                                @hidden="result = null" aria-hidden="true">
                                <b-form id="formClientCode" @submit.stop.prevent="getData('manualCode', 1)">
                                    <b-row align-h="center">
                                        <b-col cols="12" sm="10" md="9" class="mb-3" align-self="start">
                                            <b-form-group :label="labels.clientCode + ':'">
                                                <b-form-input name="manualCode" v-model="result" type="text"
                                                    class="text-center" v-validate="'required:true'"
                                                    :state="validateState('manualCode')"
                                                    :data-vv-as="(labels.clientCode).toLowerCase()"
                                                    :disabled="loadingFavs" aria-describedby="manualCode-live-feedback"
                                                    placeholder="Ej: 5bc8c567a89112d5f408a8af4f17970d"></b-form-input>
                                                <b-form-invalid-feedback id="manualCode-live-feedback">{{
                                                    veeErrors.first('manualCode')
                                                    }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" align-self="center">
                                            <b-button type="submit" variant="default" pill :disabled="loadingFavs"
                                                class="shadow px-5" form="formClientCode" size="lg">
                                                <b-spinner small type="grow" v-if="loadingFavs"></b-spinner>
                                                <b-icon icon="check-all" aria-hidden="true" v-else></b-icon>
                                                &nbsp;&nbsp;<span>{{ loadingFavs ? 'Aplicando...' : 'Aplicar' }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-modal>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 3">
                            <b-col>
                                <b-row align-h="center">
                                    <b-col cols="12" md="5" align-self="start" class="my-md-4">
                                        <b-form-group :label="labels.payment + ':'">
                                            <b-form-select name="payment" :value="form.payment" v-model="form.payment"
                                                :options="payments" v-validate="'required:true'"
                                                :state="validateState('payment')"
                                                :data-vv-as="(labels.payment).toLowerCase()"
                                                aria-describedby="payment-live-feedback"
                                                class="form-control select-center" @change="clearVoucher"
                                                :disabled="loading" size="lg"></b-form-select>
                                            <b-form-invalid-feedback id="payment-live-feedback">{{
                                                veeErrors.first('payment')
                                            }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="my-md-4"
                                        v-if="form.payment === 2">
                                        <b-form-group :label="labels.voucher + ':'" label-align="center">
                                            <b-form-file name="voucher" v-model="form.voucher"
                                                v-validate="'required:true|image|size:5120'"
                                                :data-vv-as="(labels.voucher).toLowerCase()"
                                                aria-describedby="voucher-live-feedback"
                                                :state="form.voucher ? Boolean(form.voucher) : form.voucher || validateState('voucher')"
                                                placeholder="Seleccione un archivo ..."
                                                drop-placeholder="Suelta el archivo aquí ..." accept="image/*"
                                                browse-text="Buscar" size="lg"></b-form-file>
                                            <b-form-invalid-feedback id="voucher-live-feedback">{{
                                                veeErrors.first('voucher')
                                            }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="center" class="my-md-4"
                                        v-if="form.payment === 4">
                                        <b-button size="lg" variant="default" pill class="my-4 mb-md-0 px-5 py-2"
                                            v-b-modal.partners>
                                            <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>
                                            <span>Ver Agentes de Recaudo</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row align-h="center">
                                    <b-col cols="12" md="10" class="mb-md-4 mb-2 text-center" align-self="start">
                                        <p class="text-center" v-if="form.payment === 1">♦ Al completar el proceso de
                                            envío de la información
                                            será redirigido al portal de pagos.</p>
                                        <p class="text-center" v-if="form.payment === 1">♦ Al usar este medio de pago
                                            tendrá un valor adicional
                                            de <b>{{ Number((form.type === 'S' ? form.value : form.convert) *
                                                0.04).toLocaleString('en-US',
                                                    {
                                                        minimumFractionDigits: ((form.currency === 'USD' && form.type === 'S')
                                                            || (form.cConvert ===
                                                                'USD' && form.type === 'R') ? 2 : 0), maximumFractionDigits:
                                                            ((form.currency === 'USD' &&
                                                                form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2
                                                                : 0)
                                                    }) }} {{ form.type
                                                    === 'S' ? form.currency : form.cConvert }}</b> IVA incluido.</p>
                                        <p class="text-center"
                                            v-if="form.payment === 1 && ((form.currency === 'USD' && form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R'))">
                                            ♦ Tu moneda de envío es USD para usar con este medio de pago el valor será
                                            convertido a CLP.</p>
                                        <p class="text-center" v-if="form.payment === 2">♦ Debes subir una foto del pago
                                            por un valor de <b>{{
                                                Number(form.type === 'S' ? form.value :
                                                    form.convert).toLocaleString('en-US') }} CLP</b> para
                                            que tu transferencia sea realizada con exito.</p>
                                        <p class="text-center" v-if="form.payment === 3">♦ El pago será descontado de tu
                                            saldo precargado, si no
                                            tienes saldo debes recargar antes de continuar el proceso.</p>
                                        <p class="text-center" v-if="form.payment === 4">♦ Al Completar el proceso de
                                            envío del giro, tendrá 2
                                            horas para realizar el pago en uno de nuestros agentes de recaudo.</p>
                                        <p class="text-center" v-if="form.payment === 4">♦ Si el pago no se realiza en
                                            las proximas 2 horas
                                            deberá subir un nuevo giro.</p>
                                    </b-col>
                                </b-row>
                                <b-row align-h="center">
                                    <b-col cols="12" sm="8" md="6" class="mb-md-4 mb-2 text-center" align-self="start"
                                        v-if="form.payment === 2 && imageData === null">
                                        <b-card header-class="font-weight-bold" border-variant="info"
                                            header="Información Bancaria" align="center">
                                            <b-card-sub-title class="mb-3">{{ account.name }}</b-card-sub-title>
                                            <b-card-text class="mb-1">
                                                <b-button class="py-0" variant="light"
                                                    style="text-transform: none; color: #212529"
                                                    v-clipboard:copy="account.rut" v-clipboard:success="onCopy"
                                                    v-clipboard:error="onError">{{
                                                        account.rut }}
                                                    <b-badge variant="light">
                                                        <i class="material-icons"
                                                            style="font-size: 12px">content_copy</i>
                                                    </b-badge>
                                                </b-button>
                                            </b-card-text>
                                            <b-card-text class="mb-1">{{ account.bank }}</b-card-text>
                                            <b-card-text class="mb-1">{{ account.type }}</b-card-text>
                                            <b-card-text class="mb-1">
                                                <b-button class="py-0" variant="light"
                                                    style="text-transform: none; color: #212529"
                                                    v-clipboard:copy="account.number" v-clipboard:success="onCopy"
                                                    v-clipboard:error="onError">{{ account.number }}
                                                    <b-badge variant="light">
                                                        <i class="material-icons"
                                                            style="font-size: 12px">content_copy</i>
                                                    </b-badge>
                                                </b-button>
                                            </b-card-text>
                                            <b-card-text class="mb-4">
                                                <b-button class="py-0" variant="light"
                                                    style="text-transform: none; color: #212529"
                                                    v-clipboard:copy="account.email" v-clipboard:success="onCopy"
                                                    v-clipboard:error="onError">{{
                                                        account.email }}
                                                    <b-badge variant="light">
                                                        <i class="material-icons"
                                                            style="font-size: 12px">content_copy</i>
                                                    </b-badge>
                                                </b-button>
                                            </b-card-text>
                                            <b-button variant="default" @click="sendMail">Enviar al Correo</b-button>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="5" lg="4" class="mb-md-4 mb-2" align-self="start"
                                        v-if="imageData !== null">
                                        <img :src="imageData" width="100%" alt="voucher"
                                            style="border: 1px solid #eee; border-radius: 4px;" />
                                    </b-col>
                                </b-row>

                                <!-- Modal Partners -->
                                <b-modal id="partners" centered no-fade size="xl" header-class="text-center"
                                    header-bg-variant="primary" header-text-variant="light" header-close-variant="light"
                                    footer-class="border-0" hide-footer body-class="text-center px-4 my-4"
                                    title="Oficinas y Agentes" tabindex="-1" role="dialog" aria-hidden="true">
                                    <b-row align-h="center">
                                        <template v-for="v in partners">
                                            <b-col :key="v.id || v.name" cols="12" sm="6" md="5" align-self="center" class="p-2">
                                                <b-card border-variant="primary" class="border-1"
                                                    header-class="border-bottom-1 font-weight-bold"
                                                    :header="v.name + ' [' + v.company + ']'" align="center">
                                                    <b-card-sub-title>Teléfono</b-card-sub-title>
                                                    <b-card-text>{{ v.phone }}</b-card-text>
                                                    <b-card-sub-title>Dirección</b-card-sub-title>
                                                    <b-card-text>{{ v.address }}<br>{{ v.city + ' - ' + v.country
                                                    }}</b-card-text>
                                                    <b-card-sub-title>Horario</b-card-sub-title>
                                                    <b-card-text>{{ v.open }}</b-card-text>
                                                    <b-card-sub-title>Monedas</b-card-sub-title>
                                                    <b-card-text>Local: {{ v.currency_1 === 1 ? 'Si' : 'No' }} -
                                                        Dolares: {{ v.currency_2 === 1 ? 'Si' : 'No' }}</b-card-text>
                                                    <b-button variant="default" :href="'https://goo.gl/maps/' + v.maps"
                                                        target="_blank">Ver en Google Maps</b-button>
                                                </b-card>
                                            </b-col>
                                        </template>
                                    </b-row>
                                </b-modal>
                            </b-col>
                        </b-row>
                        <b-row align-h="center" v-if="current_step === 4">
                            <b-col cols="12" md="10" class="my-md-5">
                                <p class="text-center">
                                    <strong>Por favor revise bien los datos ingresados antes de enviar esta
                                        solicitud</strong>
                                </p>
                            </b-col>
                            <b-col cols="12" md="6" class="text-center">
                                <b-table-simple stacked>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th class="text-center">Datos Ingresados</b-th>
                                            <b-td stacked-heading="Nombres">{{ form.name }}</b-td>
                                            <b-td stacked-heading="Apellidos">{{ form.lname }} {{ form.mname }}</b-td>
                                            <b-td stacked-heading="Documento">{{ form.td }} - {{ form.nd }}</b-td>
                                            <b-td stacked-heading="Email">{{ form.email }}</b-td>
                                            <b-td stacked-heading="Teléfono">{{ form.mobile }}</b-td>
                                            <b-td stacked-heading="Oficina" v-if="form.payReceiver === 'Cash'">{{
                                                form.nOffice }}</b-td>
                                            <b-td stacked-heading="Banco" v-if="form.payReceiver === 'Bank'">{{
                                                form.nBank }}</b-td>
                                            <b-td stacked-heading="Cuenta" v-if="form.payReceiver === 'Bank'">{{ form.tc
                                            }} {{ form.nc }}</b-td>
                                            <b-td stacked-heading="Dirección">{{ form.address }} {{ form.district }}, {{
                                                form.city }} - {{
                                                    form.state }}, {{ form.country }}</b-td>
                                            <b-td stacked-heading="Monto Destino">{{ Number(form.type === 'S' ?
                                                form.convert :
                                                form.value).toLocaleString('en-US', {
                                                    minimumFractionDigits:
                                                        ((form.cConvert === 'COP' &&
                                                            form.type === 'S') || (form.currency === 'COP' && form.type === 'R') ? 0
                                                            : 2),
                                                    maximumFractionDigits: ((form.cConvert === 'COP' && form.type === 'S')
                                                        || (form.currency ===
                                                            'COP' && form.type === 'R') ? 0 : 2)
                                                }) }} {{ form.type === 'S' ?
                                                    form.cConvert : form.currency
                                                }}</b-td>
                                            <b-td stacked-heading="Monto Enviado">{{ Number((form.type === 'S' ?
                                                form.value : form.convert) -
                                                fee).toLocaleString('en-US', {
                                                    minimumFractionDigits: ((form.currency ===
                                                        'USD' && form.type ===
                                                        'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0),
                                                    maximumFractionDigits:
                                                        ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                            'USD' && form.type ===
                                                            'R') ? 2 : 0)
                                                }) }} {{ form.type === 'S' ? form.currency : form.cConvert
                                                }}</b-td>
                                            <b-td stacked-heading="Comisión Gestión">{{
                                                Number(fee).toLocaleString('en-US',
                                                    {
                                                        minimumFractionDigits: ((form.currency === 'USD' && form.type === 'S')
                                                            || (form.cConvert ===
                                                                'USD' && form.type === 'R') ? 2 : 0), maximumFractionDigits:
                                                            ((form.currency === 'USD' &&
                                                                form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2
                                                                : 0)
                                                    }) }} {{ form.type
                                                    === 'S' ? form.currency : form.cConvert }}</b-td>
                                            <b-td stacked-heading="Comisión Servicios" v-if="form.payment === 1">{{
                                                Number((form.type === 'S' ?
                                                    form.value : form.convert) * 0.04).toLocaleString('en-US',
                                                        {
                                                            minimumFractionDigits:
                                                                ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                                    'USD' && form.type ===
                                                                    'R') ? 2 : 0), maximumFractionDigits: ((form.currency === 'USD' &&
                                                                        form.type === 'S') ||
                                                                        (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0)
                                                        }) }} {{
                                                    form.type === 'S' ?
                                                        form.currency : form.cConvert }}</b-td>
                                            <b-td stacked-heading="Total a Pagar" v-if="form.payment === 1">{{
                                                Number((form.type === 'S' ?
                                                    form.value : form.convert) * 1.04).toLocaleString('en-US',
                                                        {
                                                            minimumFractionDigits:
                                                                ((form.currency === 'USD' && form.type === 'S') || (form.cConvert ===
                                                                    'USD' && form.type ===
                                                                    'R') ? 2 : 0), maximumFractionDigits: ((form.currency === 'USD' &&
                                                                        form.type === 'S') ||
                                                                        (form.cConvert === 'USD' && form.type === 'R') ? 2 : 0)
                                                        }) }} {{
                                                    form.type === 'S' ?
                                                        form.currency : form.cConvert }}</b-td>
                                            <b-td stacked-heading="Total a Pagar" v-else>{{ Number(form.type === 'S' ?
                                                form.value :
                                                form.convert).toLocaleString('en-US', {
                                                    minimumFractionDigits:
                                                        ((form.currency === 'USD' &&
                                                            form.type === 'S') || (form.cConvert === 'USD' && form.type === 'R') ? 2
                                                            : 0),
                                                    maximumFractionDigits: ((form.currency === 'USD' && form.type === 'S')
                                                        || (form.cConvert ===
                                                            'USD' && form.type === 'R') ? 2 : 0)
                                                }) }} {{ form.type === 'S' ?
                                                    form.currency : form.cConvert
                                                }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-button v-if="current_step !== 1" class="float-left" variant="secondary"
                            @click="onClickBack">{{ back }}</b-button>
                        <b-button v-if="current_step === max_step" class="float-right" variant="success"
                            @click="onClickFinish" :disabled="loading">{{ finish }}</b-button>
                        <b-button v-else class="float-right" variant="default" @click="onClickNext"
                            :disabled="loading">{{ next }}</b-button>
                    </b-form>
                    <form ref="redirect" id="webpay" action="" method="post" v-if="form.payment === 1">
                        <input type="hidden" id="token_ws" name="token_ws" value="">
                    </form>
                </b-card>
            </b-col>
            <b-col cols="12" sm="10" md="8" align-self="center" v-else>
                <b-card bg-variant="transparent" align="center" class="text-center">
                    <h5 class="my-5 mx-2">Debes completar el registro para poder realizar transferencias.</h5>
                    <b-button variant="default" pill size="lg" to="/profile/information" class="px-5 py-2">
                        <i class="material-icons mdi mdi-account-circle"></i>&nbsp;
                        <span>Completar Registro</span>
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";
import { CurrencyInput } from 'vue-currency-input';
import VSelect from '@alfsnd/vue-bootstrap-select';

export default {
    name: "Request",
    props: ['user'],
    components: {
        CurrencyInput,
        VSelect
    },
    data: () => ({
        loading: false,
        loadingFavs: false,
        current_step: 1,
        max_step: 4,
        title: 'Detalles de Envío',
        subtitle: '',
        account: {
            name: 'MORE GIROS SPA',
            rut: '77.333.099-0',
            bank: 'Banco de Chile',
            type: 'Cuenta Corriente',
            number: '51541602',
            email: 'transferencias@moregiros.cl'
        },
        labels: {
            favorite: 'Destinatario',
            clientCode: 'Código del Destinatario',

            country: 'País de Destino',
            type: 'Método de Envío',
            payReceiver: 'Forma de Pago en Destino',
            value: 'Valor a Pagar',

            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            issuedBy: 'País de emisión',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',

            office: 'Oficinas de Cobro',

            bank: 'Entidad Bancaria',
            wallet: 'Wallet',
            tc: 'Tipo de Cuenta',
            nc: 'Número de Cuenta',
            cbu: 'Número CBU/CVU',
            cpf: 'Número CPF',
            nab: 'Número de Agencia Bancaria',

            address: 'Dirección',
            district: 'Comuna',
            city: 'Ciudad',
            state: 'Región',

            payment: 'Forma de Pago',
            voucher: 'Comprobante de Pago',
            convert: 'Monto en Destino',

            es: {
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Año Anterior',
                labelPrevMonth: 'Mes Anterior',
                labelCurrentMonth: 'Mes Actual',
                labelNextMonth: 'Próximo Mes',
                labelNextYear: 'Próximo Año',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoy',
                labelSelected: 'Fecha Seleccionada',
                labelNoDateSelected: 'Sin fecha seleccionada',
                labelCalendar: 'Calendario',
                labelNav: 'Navegar por el calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario'
            }
        },
        form: {
            local: 'CL',
            country: 'PE',
            type: 'S',
            payReceiver: 'Bank',
            value: 0,
            currency: 'CLP',

            accountID: 0,
            name: null,
            lname: null,
            mname: null,
            td: null,
            nd: null,
            issuedBy: null,
            email: null,
            mobile: null,

            office: null,
            nOffice: null,

            bank: null,
            nBank: null,
            tc: null,
            nc: null,
            cbu: null,
            cpf: null,
            nab: null,

            address: null,
            district: null,
            city: null,
            state: null,

            rate: 0,
            convert: 0,
            cConvert: null,

            payment: 1,
            favorite: true,

            voucher: null,
            payer: null,
            payer_code: null
        },
        countries: [
            { text: 'AR - Argentina', value: 'AR' },
            { text: 'BO - Bolivia', value: 'BO' },
            { text: 'BR - Brasil', value: 'BR' },
            { text: 'CO - Colombia', value: 'CO' },
            { text: 'DE - Alemania', value: 'DE' },
            { text: 'DO - Rep. Dominicana', value: 'DO' },
            { text: 'EC - Ecuador', value: 'EC' },
            { text: 'ES - España', value: 'ES' },
            { text: 'FR - Francia', value: 'FR' },
            { text: 'HT - Haiti', value: 'HT' },
            { text: 'IT - Italia', value: 'IT' },
            { text: 'PE - Perú', value: 'PE' },
            { text: 'US - Estados Unidos', value: 'US' },
            { text: 'VE - Venezuela', value: 'VE' }
        ],
        types: [
            { text: 'Remitente', value: 'S', disabled: false },
            { text: 'Beneficiario', value: 'R', disabled: false }
        ],
        payReceivers: [
            { text: 'Abono a Cta', value: 'Bank', disabled: false },
            { text: 'Ventanilla', value: 'Cash', disabled: false },
            { text: 'Wallet', value: 'Wallet', disabled: false }
        ],
        currencies: [
            { tm: 1, code: 'CLP', type: 'S', country: 'CL', name: 'Pesos Chilenos' },
            { tm: 2, code: 'USD', type: 'S', country: 'CL', name: 'Dolares' },
            { tm: 1, code: 'PEN', type: 'R', country: 'PE', name: 'Nuevos Soles', enabled: true },
            { tm: 2, code: 'USD', type: 'R', country: 'PE', name: 'Dolares', enabled: true }
        ],
        collections: [],
        payments: [
            { text: 'Tarjetas Debito/Crédito', value: 1 },
            { text: 'Deposito/Transferencia', value: 2 },
            { text: 'Efectivo', value: 4 }
        ],
        countries_list: [],
        accounts: [],
        accountSelected: null,
        partners: [],
        offices: [],
        officeSelected: null,
        banks: [],
        bankSelected: null,
        tc: [
            { value: 'Ahorros', text: 'Cuenta de Ahorros' },
            { value: 'Corriente', text: 'Cuenta Corriente' }
        ],
        back: 'Atras',
        next: 'Siguiente',
        finish: 'Finalizar',
        camera: 'auto',
        isValid: undefined,
        loadIcon: '/img/synchronization.svg',
        uncheckIcon: '/img/x-mark.svg',
        checkIcon: '/img/checkmark.svg',
        qrReaderLoading: true,
        fileName: '',
        result: null,
        imageData: null,
        feeData: [],
        fee: 0,
        minData: {},
        min: 0,
        maxData: {},
        max: 0,
        quotes: [],
        currency_precision: 0
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'requestpage');
        this.form.country = this.$route.query.country ? this.$route.query.country : 'PE';
        this.form.type = this.$route.query.type ? this.$route.query.type : 'S';
        this.form.currency = this.$route.query.currency ? this.$route.query.currency : 'CLP';
        this.form.value = parseFloat(this.$route.query.value ? (this.$route.query.value).toString() : 0);
        if (this.form.currency !== 'CLP' && this.form.currency !== 'COP') {
            this.currency_precision = 2;
        }
        this.getIni();
    },
    watch: {
        accountSelected() {
            let accounts = this.accounts;

            for (let i = 0; i < accounts.length; i++) {
                if (accounts[i] === this.accountSelected) {
                    this.form.accountID = accounts[i].id;
                }
            }
        },
        'form.accountID'() {
            if (this.form.accountID === 0) {
                this.accountSelected = null;
            } else {
                let accounts = this.accounts;

                for (let i = 0; i < accounts.length; i++) {
                    if (accounts[i].id === this.form.accountID) {
                        this.accountSelected = accounts[i];
                    }
                }
            }
        },
        'form.country'() {
            this.bankSelected = null;
            this.officeSelected = null;
            this.resetData(this.form.local, this.form.country, this.form.type, this.form.currency, this.form.value);
            this.getIni();
        },
        'form.payReceiver'() {
            if (this.form.payReceiver === 'Cash' && (this.form.country === 'BR' || this.form.country === 'VE')) {
                this.form.payReceiver = 'Bank';
            }
            this.payReceivers[1].disabled = (this.form.country === 'BR' || this.form.country === 'VE');
            if (this.form.payReceiver === 'Cash') {
                this.bankSelected = null;
                this.officeSelected = this.offices[0];
            } else if (this.form.payReceiver === 'Bank') {
                this.officeSelected = null;
                this.bankSelected = this.banks[0];
            }
        },
        officeSelected() {
            if (this.officeSelected) {
                let offices = this.offices;

                for (let i = 0; i < offices.length; i++) {
                    if (offices[i] === this.officeSelected) {
                        this.form.office = offices[i].code;
                        this.form.nOffice = offices[i].name;
                        this.form.payer_code = offices[i].payer_id;
                        this.form.payer = offices[i].group;
                    }
                }
            } else {
                this.form.office = null;
                this.form.nOffice = null;
            }
        },
        bankSelected() {
            if (this.bankSelected) {
                let banks = this.banks;
                for (let i = 0; i < banks.length; i++) {
                    if (banks[i] === this.bankSelected) {
                        this.form.bank = banks[i].code;
                        this.form.nBank = banks[i].name;
                        this.form.payer_code = banks[i].payer_id;
                        this.form.payer = banks[i].group;
                    }
                }
            } else {
                this.form.bank = null;
                this.form.nBank = null;
            }
        },
        'form.payer_code'() {
            this.getSettings();
        },
        'form.type'() {
            this.labels.value = 'Valor a Pagar';
            this.labels.convert = 'Monto en Destino';
            if (this.form.type === 'R') {
                this.labels.value = 'Monto en Destino';
                this.labels.convert = 'Valor a Pagar';
            }
            this.form.rate = 0;
            this.form.convert = 0;
            this.form.cConvert = null;
            this.quotes = [];
            this.getCurrency();
        },
        'form.value'() {
            this.getQuotes();
        },
        'form.currency'() {
            let decimals = 2;
            let collections = this.collections;
            let min = this.minData.data.value;
            let max = this.maxData.data.value;
            let payer = this.form.payer;
            if (this.form.type === "S") {
                let fee = 0;
                let feeData = this.feeData;
                for (let u = 0; u < feeData.length; u++) {
                    if (min > feeData[u].data.min && min <= feeData[u].data.max && payer === feeData[u].data.payer) {
                        let fc = 0;
                        let ft = feeData[u].item;
                        let fv = feeData[u].data.value;
                        let ftc = feeData[u].data.tc;
                        let fvc = feeData[u].data.com;

                        if (ft === '%') {
                            if (ftc === '%') {
                                fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                fee = (min / 100) * fc;
                            } else {
                                fee = (min / 100) * fv;
                                fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                            }
                        } else if (ft === '=') {
                            fc = fvc;
                            if (ftc === '%') {
                                fc = (min / 100) * fvc;
                            }
                            fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                        }
                    }
                }
                min = min + fee;
            }
            for (let i = 0; i < collections.length; i++) {
                if (collections[i].code_send === this.form.currency &&
                    collections[i].country_send === this.form.local) {
                    if (collections[i].code_send !== 'USD') {
                        decimals = 0;
                        min = min / collections[i].value;
                        max = max / collections[i].value;
                    }
                } else if (collections[i].code_receiver === this.form.currency &&
                    collections[i].country_receiver === this.form.country) {
                    if (collections[i].code_receiver !== 'USD') {
                        min = min * collections[i].value;
                        max = max * collections[i].value;
                    }
                }
            }
            this.min = parseFloat(min.toFixed(decimals));
            this.max = parseFloat(max.toFixed(decimals));
            if (this.form.value >= min && this.form.value <= max) {
                this.getQuotes();
            } else {
                this.form.value = 0;
            }
            this.currency_precision = this.form.currency === 'CLP' || this.form.currency === 'COP' ? 0 : 2;
        },
        'form.convert'() {
            let fee = 0;
            let fx_rate = 1;
            let quotes = this.quotes;

            for (let i = 0; i < quotes.length; i++) {
                if (quotes[i].value === this.form.convert) {
                    this.form.cConvert = quotes[i].code;
                    fee = parseFloat((quotes[i].data.fee).toFixed(2));
                    if (this.form.type === 'S' && this.form.currency !== 'USD') {
                        fee = parseFloat((quotes[0].data.fee).toFixed(2));
                    }
                }
                let cSend = this.form.currency;
                let cReceiver = this.form.cConvert;
                if (this.form.type === 'R') {
                    cSend = this.form.cConvert;
                    cReceiver = this.form.currency;
                }
                if (cSend !== cReceiver) {
                    if (cSend === quotes[i].data.code_send) {
                        if (this.form.type === 'S') {
                            fx_rate = quotes[i].data.fx;
                        } else if (this.form.type === 'R') {
                            fx_rate = fx_rate * quotes[i].data.fx;
                        }
                    } else if (cReceiver === quotes[i].data.code_receiver) {
                        if (this.form.type === 'S') {
                            fx_rate = fx_rate * quotes[i].data.fx;
                        } else if (this.form.type === 'R') {
                            fx_rate = quotes[i].data.fx;
                        }
                    }
                }
            }
            this.fee = fee;
            this.form.rate = fx_rate;
        },
        'form.td'() {
            if (!/^([0-9])*$/.test(this.form.nd) && this.form.td !== 'PS') {
                this.form.nd = null;
            }
            if (this.form.td === 'PS' && this.form.nd) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.nd'() {
            if (this.typeND) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.bank'() {
            if (this.form.bank) {
                this.getAccounts();
            }
        },
        'form.nc'() {
            if (this.typeNC) {
                this.form.nc = (this.form.nc).toUpperCase();
            }
        },
        'form.voucher'() {
            if (this.form.voucher) {
                this.getVoucher();
            }
        }
    },
    computed: {
        td() {
            let td = [
                { value: 'DNI', text: 'Documento Nacional de Identidad' },
                { value: 'CI', text: 'Cedula de Identidad' },
                { value: 'CE', text: 'Cedula de Extranjeria' },
                { value: 'PS', text: 'Pasaporte' }
            ];
            if (this.form.country === 'AR' && this.form.payReceiver === 'Bank') {
                td = [
                    { value: 'CUIT', text: 'CUIT/CUIL' }
                ];
                this.form.td = 'CUIT';
            } else if (this.form.country === 'CO' && this.form.payer === 'HSTECH') {
                td = [
                    { value: 'NIT', text: 'Número de Identificación Tributaria' }
                ];
                this.form.td = 'NIT';
            }
            return td;
        },
        typeND() {
            return this.form.td === 'PS' || (this.form.td === 'CI' && this.form.country === 'BO') ||
                this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateND() {
            let nd = '';
            if (this.form.td !== 'PS') {
                if (this.form.country === 'AR') {
                    if (this.form.payReceiver === 'Bank') {
                        nd += '|numeric|digits:11|cuit';
                    } else {
                        nd += '|numeric|digits:8';
                    }
                } else if (this.form.country === 'CO') {
                    nd += '|numeric|min:6';
                    if (this.form.td === 'CE') {
                        nd += '|max:7';
                    } else {
                        nd += '|max:10';
                    }
                } else if (this.form.country === 'EC') {
                    nd += '|numeric|min:10|max:15';
                } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                    this.form.country === 'IT') {
                    nd += '|min:6|max:19|alpha_num|tn';
                }
            } else if (this.form.country === 'AR') {
                nd += '|min:8|max:10';
            }
            return nd;
        },
        vMobile() {
            let m = '';
            if (this.form.country === 'AR') {
                m += '|digits:11';
            } else if (this.form.country === 'CO') {
                m += '|digits:10';
            } else if (this.form.country === 'EC' || this.form.country === 'PE') {
                m += '|digits:9';
            }
            return m;
        },
        typeNC() {
            return this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT';
        },
        validateNC() {
            let nc = '|numeric';
            if (this.form.country === 'VE') {
                nc += '|digits:20';
            } else if (this.form.country === 'DE' || this.form.country === 'ES' || this.form.country === 'FR' ||
                this.form.country === 'IT') {
                nc = '|min:14|max:32|alpha_num|tn';
            } else if (this.form.country === 'CO') {
                let bank = this.form.bank !== null ? (this.form.bank).slice(4) : '';
                if (bank === 'CCAICOBB' || bank === 'PICHCOBB' || bank === 'BPOPCOBB') {
                    nc += '|min:9|max:12';
                } else if (bank === 'BAVICOBB') {
                    nc += '|min:9';
                    if (this.form.tc === 'Ahorros') {
                        nc += '|max:11';
                    } else if (this.form.tc === 'Corriente') {
                        nc += '|max:13';
                    }
                } else if (bank === 'CASOCOBB' || bank === 'FIACCOB1') {
                    nc += '|min:11|max:12';
                } else if (bank === 'COLPCOBB') {
                    nc += '|min:9|max:10';
                } else if (bank === 'CAFECOBB') {
                    nc += '|min:12|max:16';
                } else if (bank === 'OCCICOBC' || bank === 'BCTOCOBB' || bank === 'LP001292') {
                    nc += '|digits:9';
                } else if (bank === 'CITICO21' || bank === 'LP001507') {
                    nc += '|digits:10';
                } else if (bank === 'COLOCOBM') {
                    nc += '|digits:11';
                } else if (bank === 'FALACOBB') {
                    nc += '|digits:12';
                } else if (bank === 'PRCBCOBB' || (bank === 'LP001289' && this.form.tc === 'Corriente')) {
                    nc += '|digits:13';
                } else if (bank === 'FBBVCOBB') {
                    nc += '|min:9|max:20';
                } else if (bank === 'BSUDCOBB') {
                    nc += '|min:8|max:11';
                } else {
                    nc += '|min:5|max:20';
                }
            } else if (this.form.country === 'BO') {
                const code = this.form.bank != null ? String(this.form.bank) : '';
                if (window.BO_JETPERU_WALLET_BANK_CODES.includes(code)) {
                    nc += '|digits:8|bo_wallet_phone';
                } else {
                    nc += '|min:5|max:20';
                }
            } else if (this.form.country === 'EC') {
                nc += '|min:6|max:34';
            }
            return nc;
        },
        progress() {
            return Math.round(100 / this.max_step) * this.current_step;
        },
        validationPending() {
            return this.isValid === undefined
                && this.camera === 'off';
        },
        validationSuccess() {
            return this.isValid === true;
        },
        validationFailure() {
            return this.isValid === false;
        }
    },
    methods: {
        getRCurrency(n) {
            this.currencies = [
                { tm: 1, code: 'CLP', type: 'S', country: 'CL', name: 'Pesos Chilenos' },
                { tm: 2, code: 'USD', type: 'S', country: 'CL', name: 'Dolares' }
            ];

            if (n > 1) {
                let code = 'EUR';
                let name = 'Euros';
                let value = false;
                if (this.form.country === 'AR') {
                    code = 'ARS';
                    name = 'Pesos Argentinos';
                } else if (this.form.country === 'BO') {
                    code = 'BOB';
                    name = 'Bolivianos';
                    value = true;
                } else if (this.form.country === 'BR') {
                    code = 'BRL';
                    name = 'Reales';
                } else if (this.form.country === 'CO') {
                    code = 'COP';
                    name = 'Pesos Colombianos';
                } else if (this.form.country === 'HT') {
                    code = 'HTG';
                    name = 'Gourde';
                    value = true;
                } else if (this.form.country === 'DO') {
                    code = 'DOP';
                    name = 'Pesos Dominicanos';
                    value = true;
                } else if (this.form.country === 'PE') {
                    code = 'PEN';
                    name = 'Nuevos Soles';
                    value = true;
                } else if (this.form.country === 'VE') {
                    code = 'VES';
                    name = 'Bolivares';
                }

                this.currencies[2] = { tm: 1, code: code, type: 'R', country: this.form.country, name: name, enabled: true };
                this.currencies[3] = { tm: 2, code: 'USD', type: 'R', country: this.form.country, name: 'Dolares', enabled: value };
            } else {
                this.currencies[2] = { tm: 2, code: 'USD', type: 'R', country: this.form.country, name: 'Dolares', enabled: true };
            }
        },
        getIni() {
            this.loading = true;
            this.getBanks();
            this.getOffices();
            this.getPartners();
            // console.log('USERS:', this.users)
        },
        getBanks() {
            this.banks = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/banks').then((res) => {
                this.banks = res.data.banks;
                if (this.form.payReceiver === 'Bank' && this.bankSelected === null) {
                    this.bankSelected = res.data.banks[0];
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getOffices() {
            this.offices = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/offices').then((res) => {
                let offices = res.data.offices;
                for (let i = 0; i < offices.length; i++) {
                    offices[i].name = offices[i].payer + ' - ' + offices[i].name + ' - ' + offices[i].city;
                }
                this.offices = offices;
                if ((this.offices).length > 0) {
                    if (this.form.payReceiver === 'Cash' && this.officeSelected === null) {
                        this.officeSelected = res.data.offices[0];
                    }
                } else {
                    if (this.form.payReceiver === 'Cash') {
                        this.form.payReceiver = 'Bank';
                        this.officeSelected = null;
                    }
                    this.payReceivers[1].disabled = true;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getPartners() {
            let country = this.form.local;
            axios.get('/api/customer/' + country + '/partners').then((res) => {
                this.partners = res.data.partners;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getSettings() {
            this.loading = true;
            let send = this.form.local;
            let receiver = this.form.country;
            let payer = this.form.payer ? this.form.payer : 0;
            let payer_id = this.form.payer_code ? this.form.payer_code : 0;
            axios.get('/api/customer/request/settings/' + payer + '/' + payer_id + '/' + send + '/' + receiver).then((res) => {
                if (res.data.status === 'success') {
                    this.countries_list = res.data.countries;
                    this.collections = res.data.currencies;
                    this.minData = res.data.min;
                    this.maxData = res.data.max;
                    this.feeData = res.data.fee;
                    this.account = res.data.account;
                    this.getRCurrency((res.data.currencies).length);

                    let decimals = 2;
                    let collections = res.data.currencies;
                    let min = res.data.min.data.value;
                    let max = res.data.max.data.value;
                    if (this.form.type === "S") {
                        let fee = 0;
                        let feeData = res.data.fee;
                        for (let u = 0; u < feeData.length; u++) {
                            if (min > feeData[u].data.min && min <= feeData[u].data.max &&
                                payer === feeData[u].data.payer) {
                                let fc = 0;
                                let ft = feeData[u].item;
                                let fv = feeData[u].data.value;
                                let ftc = feeData[u].data.tc;
                                let fvc = feeData[u].data.com;

                                if (ft === '%') { // porcentaje
                                    if (ftc === '%') {
                                        // ((valor - comision) * (1 + 19%)) + comision
                                        fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                        fee = (min / 100) * fc;
                                    } else {
                                        fee = (min / 100) * fv;
                                        fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                    }
                                } else if (ft === '=') { // fijo
                                    fc = fvc;
                                    if (ftc === '%') {
                                        fc = (min / 100) * fvc;
                                    }
                                    fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                }
                                
                            }
                        }
                        min = min + fee;
                    }
                    for (let i = 0; i < collections.length; i++) {
                        if (collections[i].code_send === this.form.currency &&
                            collections[i].country_send === this.form.local) {
                            if (collections[i].code_send !== 'USD') {
                                decimals = 0;
                                min = min / collections[i].value;
                                max = max / collections[i].value;
                            }
                        } else if (collections[i].code_receiver === this.form.currency &&
                            collections[i].country_receiver === this.form.country) {
                            if (collections[i].code_receiver !== 'USD') {
                                min = min * collections[i].value;
                                max = max * collections[i].value;
                            }
                        }
                    }
                    this.min = parseFloat(min.toFixed(decimals));
                    this.max = parseFloat(max.toFixed(decimals));
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
                this.getCurrency();
                this.getAccounts();
                if (this.form.value > this.min && this.form.value <= this.max) {
                    this.getQuotes();
                } else {
                    this.form.value = 0;
                }
            });
        },
        getAccounts() {
            this.accounts = [];
            let country = this.form.country;
            let bank = this.form.bank;
            if (this.form.payReceiver === 'Cash') {
                bank = 'all';
            }
            axios.get('/api/customer/' + country + '/' + bank + '/favorites').then((res) => {
                if (res.data.status === 'success') {
                    let favs = res.data.favorites;

                    for (let i = 0; i < favs.length; i++) {
                        if (favs[i].country === this.form.country) {
                            this.accounts.push(favs[i]);
                        }
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getVoucher() {
            const input = this.form.voucher;

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    this.imageData = e.target.result;
                };
                reader.readAsDataURL(input);
            }
        },
        clearVoucher() {
            this.form.voucher = null;
            this.imageData = null;
        },
        getCurrency() {
            if (this.$route.query.type !== this.form.type) {
                this.form.currency = 'CLP';
                if (this.form.type === 'R') {
                    this.form.currency = 'EUR';
                    if (this.form.country === 'AR') {
                        this.form.currency = 'ARS';
                    } else if (this.form.country === 'BO') {
                        this.form.currency = 'BOB';
                    } else if (this.form.country === 'BR') {
                        this.form.currency = 'BRL';
                    } else if (this.form.country === 'CO') {
                        this.form.currency = 'COP';
                    } else if (this.form.country === 'HT') {
                        this.form.currency = 'HTG';
                    } else if (this.form.country === 'DO') {
                        this.form.currency = 'DOP';
                    } else if (this.form.country === 'EC' || this.form.country === 'US') {
                        this.form.currency = 'USD';
                    } else if (this.form.country === 'PE') {
                        this.form.currency = 'PEN';
                    } else if (this.form.country === 'VE') {
                        this.form.currency = 'VES';
                    }
                }
                this.$route.query.type = null;
            }

            if (this.form.value >= this.min && this.form.value <= this.max) {
                this.getQuotes();
            } else {
                this.form.value = 0;
            }
        },
        getQuotes() {
            this.$validator.validate('value').then(result => {
                if (!result) {
                    return;
                }
                let quotes = [];
                if (this.form.value > 0) {
                    let fee = 0;
                    let feeData = this.feeData;
                    let ft = '%';
                    let fv = 0;
                    let ftc = '%';
                    let fvc = 0;
                    let type = this.form.type;
                    let amount = this.form.value;
                    let currency = this.form.currency;
                    let currencies = this.currencies;
                    let collections = this.collections;
                    let payer = this.form.payer;

                    for (let i = 0; i < currencies.length; i++) {
                        if (type === 'S' && currencies[i].code === currency) {
                            if (currencies[i].tm === 1) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        let val = amount * collections[f].value;
                                        if (val > feeData[u].data.min && val <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            let count = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%' && fee === 0) {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = amount - (amount / (1 + (0.01 * fc)));
                                                } else {
                                                    fc = fvc;
                                                    if (collections[f].code_send === currency) {
                                                        fc = fc / collections[f].value;
                                                    }
                                                    fv = fv * (1 + feeData[u].data.tax);
                                                    fee = amount - (amount / (1 + (0.01 * fv)));
                                                    fee = fee - ((fc * feeData[u].data.tax) / (1 + (0.01 * fv)));
                                                }
                                            } else if (ft === '=' && fee === 0) {
                                                fc = fvc;
                                                fee = fv;
                                                if (collections[f].code_send === currency) {
                                                    fee = fv / collections[f].value;
                                                }
                                                if (ftc === '%') {
                                                    fc = amount - (amount / (1 + (0.01 * fc)));
                                                } else if (ftc === '=' && collections[f].code_send === currency) {
                                                    fc = fc / collections[f].value;
                                                }
                                                fee = ((fee - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (collections[f].code_send === currency) {
                                                let value = (amount - fee) * collections[f].value;
                                                currency = collections[f].code_receiver;
                                                quotes.push({
                                                    text: Number(value.toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: parseFloat(collections[f].code_send === 'USD' ? fee : fee * collections[f].value),
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver: value,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                                fee = parseFloat(fee * collections[f].value);
                                                amount = parseFloat((amount * collections[f].value).toFixed(2));
                                                count++;
                                            }

                                            if (f === collections.length && count === 0) {
                                                quotes.push({
                                                    text: Number((amount - fee).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount - fee).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        amount_send: amount,
                                                        code_send: currency,
                                                        country_send: this.form.local,
                                                        amount_receiver: amount - fee,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            } else if (currencies[i].tm === 2) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        if (amount > feeData[u].data.min && amount <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = amount - (amount / (1 + (0.01 * fc)));
                                                } else {
                                                    fc = fvc;
                                                    fv = fv * (1 + feeData[u].data.tax);
                                                    fee = amount - (amount / (1 + (0.01 * fv)));
                                                    fee = fee - ((fc * feeData[u].data.tax) / (1 + (0.01 * fv)));
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                fee = fv;
                                                if (ftc === '%') {
                                                    fc = amount - (amount / (1 + (0.01 * fc)));
                                                }
                                                fee = ((fee - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (!quotes[0]) {
                                                quotes.push({
                                                    text: Number((amount - fee).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount - fee).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver: amount - fee,
                                                        code_receiver: collections[f].code_send,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }

                                            if (collections[f].code_send === currency) {
                                                let value = (amount - fee) * collections[f].value;
                                                currency = collections[f].code_receiver;
                                                quotes.push({
                                                    text: Number(value.toFixed(collections[f].code_receiver === 'COP' ? 0 : 2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(collections[f].code_receiver === 'COP' ? 0 : 2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        amount_send: amount,
                                                        code_send: collections[f].code_send,
                                                        country_send: collections[f].country_send,
                                                        amount_receiver: value,
                                                        code_receiver: currency,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        } else if (type === 'R' && currencies[i].code === currency) {
                            if (currencies[i].tm === 1) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        let value = amount / collections[f].value;
                                        if (value > feeData[u].data.min && value <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = (value / 100) * fc;
                                                } else {
                                                    fee = (value / 100) * fv;
                                                    fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                if (ftc === '%') {
                                                    fc = (value / 100) * fvc;
                                                }
                                                fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (collections[f].code_receiver === currency) {
                                                value = value + fee;
                                                currency = collections[f].code_send;
                                                quotes.push({
                                                    text: Number(value.toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        amount_send: value,
                                                        code_send: currency,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                                amount = value - fee;
                                            }
                                        }
                                    }
                                }
                            } else if (currencies[i].tm === 2) {
                                for (let f = 0; f < collections.length; f++) {
                                    for (let u = 0; u < feeData.length; u++) {
                                        if (amount > feeData[u].data.min && amount <= feeData[u].data.max &&
                                            payer === feeData[u].data.payer) {
                                            let fc = 0;
                                            ft = feeData[u].item;
                                            fv = feeData[u].data.value;
                                            ftc = feeData[u].data.tc;
                                            fvc = feeData[u].data.com;

                                            if (ft === '%') {
                                                if (ftc === '%') {
                                                    fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                    fee = (amount / 100) * fc;
                                                } else {
                                                    fee = (amount / 100) * fv;
                                                    fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                                }
                                            } else if (ft === '=') {
                                                fc = fvc;
                                                if (ftc === '%') {
                                                    fc = (amount / 100) * fvc;
                                                }
                                                fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                            }

                                            if (!quotes[0]) {
                                                quotes.push({
                                                    text: Number((amount + fee).toFixed(2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat((amount + fee).toFixed(2)),
                                                    code: currency,
                                                    data: {
                                                        fx: 1,
                                                        fee: fee,
                                                        fee_usd: fee,
                                                        amount_send: parseFloat(amount + fee),
                                                        code_send: collections[f].code_receiver,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }

                                            if (collections[f].code_receiver === currency) {
                                                let value = (amount + fee) / collections[f].value;
                                                currency = collections[f].code_send;
                                                quotes.push({
                                                    text: Number(value.toFixed(collections[f].code_send === 'CLP' ? 0 : 2)).toLocaleString('en-US') + ' ' + currency,
                                                    value: parseFloat(value.toFixed(collections[f].code_send === 'CLP' ? 0 : 2)),
                                                    code: currency,
                                                    data: {
                                                        fx: parseFloat(collections[f].value),
                                                        fee: parseFloat(fee / collections[f].value),
                                                        fee_usd: fee,
                                                        amount_send: parseFloat(value),
                                                        code_send: currency,
                                                        country_send: collections[f].country_send ? collections[f].country_send : this.form.local,
                                                        amount_receiver: amount,
                                                        code_receiver: collections[f].code_receiver,
                                                        country_receiver: this.form.country
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    quotes[0].disabled = (this.form.country === 'AR' || this.form.country === 'BR' || this.form.country === 'CO' || this.form.country === 'VE') && type === 'S';
                    this.form.convert = quotes[1] ? quotes[1].value : quotes[0].value;
                    this.quotes = quotes;
                }
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        onClickNext() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.current_step++;
                this.updateTitle(this.current_step);
            });
        },
        onClickBack() {
            this.current_step--;
            this.updateTitle(this.current_step);
        },
        updateTitle(v) {
            this.title = 'Detalles de Envío';
            if (v === 2) {
                this.title = 'Datos del Destinatario';
            } else if (v === 3) {
                this.title = 'Método de Pago';
            } else if (v === 4) {
                this.title = 'Resumen';
            }
        },
        onClickFinish() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;

                let formData = new FormData();

                formData.append('local', this.form.local);
                formData.append('country', this.form.country);
                formData.append('type', this.form.type);
                formData.append('payReceiver', this.form.payReceiver);
                formData.append('value', this.form.value);
                formData.append('currency', this.form.currency);

                formData.append('account_id', this.form.accountID);
                formData.append('name', this.form.name);
                formData.append('lname', this.form.lname);
                formData.append('mname', this.form.mname);
                formData.append('td', this.form.td);
                formData.append('nd', this.form.nd);
                formData.append('issuedBy', this.form.issuedBy);
                formData.append('email', this.form.email);
                formData.append('mobile', this.form.mobile);

                formData.append('office', this.form.office);

                formData.append('bank', this.form.bank);
                formData.append('tc', this.form.tc);
                formData.append('nc', this.form.nc);
                formData.append('cbu', this.form.cbu);
                formData.append('cpf', this.form.cpf);
                formData.append('nab', this.form.nab);

                formData.append('address', this.form.address);
                formData.append('district', this.form.district);
                formData.append('city', this.form.city);
                formData.append('state', this.form.state);

                formData.append('fee', this.fee);
                formData.append('rate', this.form.rate);
                formData.append('convert', this.form.convert);
                formData.append('cConvert', this.form.cConvert);

                formData.append('payment', this.form.payment);
                formData.append('favorite', this.form.favorite ? 'Y' : 'N');
                formData.append('voucher', this.form.voucher);
                formData.append('payer', this.form.payer);
                formData.append('payer_code', this.form.payer_code);
                formData.append('quotes', JSON.stringify(this.quotes));

                axios.post( '/api/customer/request/send', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(res => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$emit('notifications');
                    if (res.data.status === 'info') {
                        document.getElementById('webpay').action = res.data.tb_url;
                        document.getElementById('token_ws').value = res.data.tb_token;
                        this.$refs.redirect.submit();
                    } else if (res.data.status === 'success') {
                        this.$router.push({ name: 'Result' });
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                });
            });
        },
        async onInit(promise) {
            try {
                await promise;
            } catch (e) {
                console.error(e);
            } finally {
                this.resetValidationState();
                this.qrReaderLoading = false;
            }
        },
        async onDecode(content) {
            this.result = content;
            this.turnCameraOff();

            await this.getData('qrReader', 1);
        },
        getData(k, v) {
            this.$validator.validate(k).then(result => {
                if (!result) {
                    return;
                }
                this.loadingFavs = true;
                const pay = this.form.payReceiver;
                if (v) {
                    let formData = new FormData();
                    formData.append('id', this.result);
                    formData.append('country', this.form.country);
                    axios.post('/api/customer/details', formData).then(res => {
                        if (res.data.status === 'success') {
                            this.isValid = true;
                            const receiver = res.data.receiver;
                            let lname = (receiver.lname).split(', ', 2);

                            this.form.name = receiver.name;
                            this.form.lname = lname[0];
                            this.form.mname = lname[1] ? lname[1] : '';
                            this.form.td = receiver.td;
                            this.form.nd = receiver.nd;
                            this.form.issuedBy = receiver.issuedBy;
                            this.form.email = receiver.email;
                            this.form.mobile = receiver.mobile;
                            if (pay === 'Bank') {
                                //this.form.office = null;
                                //this.form.bank = receiver.bank;
                                this.form.tc = receiver.tc;
                                this.form.nc = receiver.nc;
                                if (this.form.country === 'AR') {
                                    this.form.cbu = items[i].details.cbu;
                                }
                                if (this.form.country === 'BR') {
                                    this.form.cpf = receiver.details.cpf;
                                    this.form.nab = receiver.details.nab;
                                }
                            } else if (pay === 'Cash') {
                                //this.form.office = null;
                                //this.form.bank = null;
                                this.form.tc = null;
                                this.form.nc = null;
                                if (this.form.country === 'AR') {
                                    this.form.cbu = null;
                                }
                                if (this.form.country === 'BR') {
                                    this.form.cpf = null;
                                    this.form.nab = null;
                                }
                            }
                            this.form.address = receiver.address;
                            this.form.district = receiver.district;
                            this.form.city = receiver.city;
                            this.form.state = receiver.state;

                            this.$bvModal.hide(k);
                            setTimeout(this.reloadCamera, 2000);
                        } else {
                            this.$root.$bvToast.toast(res.data.msg, {
                                title: 'Notificación',
                                headerClass: 'd-none',
                                variant: res.data.status,
                                toaster: 'b-toaster-top-right',
                                autoHideDelay: 5000,
                                solid: true,
                                appendToast: true
                            });
                            this.isValid = false;
                            this.turnCameraOn();
                            setTimeout(this.reloadCamera, 3000);
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).then(() => {
                        this.loadingFavs = false;
                    });
                } else {
                    if (this.form.accountID > 0) {
                        let items = this.accounts;
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].id === this.form.accountID) {
                                let lname = (items[i].lname).split(', ', 2);

                                this.form.name = items[i].name;
                                this.form.lname = lname[0];
                                this.form.mname = lname[1] ? lname[1] : '';
                                this.form.td = items[i].td;
                                this.form.nd = items[i].nd;
                                this.form.issuedBy = items[i].issuedBy;
                                this.form.email = items[i].email;
                                this.form.mobile = items[i].mobile;
                                if (pay === 'Bank') {
                                    //this.form.office = null;
                                    //this.form.bank = items[i].bank;
                                    this.form.tc = items[i].tc;
                                    this.form.nc = items[i].nc;
                                    if (this.form.country === 'AR') {
                                        this.form.cbu = items[i].details.cbu;
                                    }
                                    if (this.form.country === 'BR') {
                                        this.form.cpf = items[i].details.cpf;
                                        this.form.nab = items[i].details.nab;
                                    }
                                } else if (pay === 'Cash') {
                                    //this.form.office = null;
                                    //this.form.bank = null;
                                    this.form.tc = null;
                                    this.form.nc = null;
                                    if (this.form.country === 'AR') {
                                        this.form.cbu = null;
                                    }
                                    if (this.form.country === 'BR') {
                                        this.form.cpf = null;
                                        this.form.nab = null;
                                    }
                                }
                                this.form.address = items[i].address;
                                this.form.district = items[i].district;
                                this.form.city = items[i].city;
                                this.form.state = items[i].state;
                                this.form.favorite = true;
                                this.isValid = true;
                                this.$bvModal.hide(k);
                            }
                        }
                    }
                    this.loadingFavs = false;
                }
            });
        },
        clearData() {
            this.form.accountID = 0;
            this.form.name = null;
            this.form.lname = null;
            this.form.mname = null;
            this.form.td = null;
            this.form.nd = null;
            this.form.issuedBy = null;
            this.form.email = null;
            this.form.mobile = null;

            //this.form.office = null;
            //this.form.bank = null;
            this.form.tc = null;
            this.form.nc = null;
            this.form.cbu = null;
            this.form.cpf = null;
            this.form.nab = null;

            this.form.address = null;
            this.form.district = null;
            this.form.city = null;
            this.form.state = null;

            this.form.favorite = true;

            this.$validator.reset();
            this.$root.$bvToast.toast('¡Ingrese los nuevos datos!', {
                title: 'Felicitaciones',
                headerClass: 'd-none',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        },
        sendMail() {
            axios.get('/api/customer/bank/account/send').then((res) => {
                if (res.data.status === 'success') {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        turnCameraOn() {
            this.camera = 'auto';
        },
        turnCameraOff() {
            this.camera = 'off';
        },
        reloadCamera() {
            this.isValid = undefined;
        },
        onCopy(e) {
            this.$root.$bvToast.toast('Se copió en el portapapeles.', {
                title: e.text,
                headerClass: 'd-none',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        },
        onError(e) {
            this.$root.$bvToast.toast('No se copió al portapapeles.', {
                title: 'Error',
                headerClass: 'd-none',
                variant: 'error',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            console.log(e);
        },
        resetData(local, country, type, currency, value) {
            let payer = this.form.payer;
            let payReceiver = this.form.payReceiver;
            this.form = {
                local: local,
                country: country,
                type: type,
                payReceiver: payReceiver,
                value: value,
                currency: currency,

                accountID: 0,
                name: null,
                lname: null,
                mname: null,
                td: null,
                nd: null,
                issuedBy: null,
                email: null,
                mobile: null,

                office: null,
                nOffice: null,

                bank: null,
                nBank: null,
                tc: null,
                nc: null,
                cbu: null,
                cpf: null,
                nab: null,

                address: null,
                district: null,
                city: null,
                state: null,

                rate: 0,
                convert: 0,
                cConvert: null,

                payment: 1,
                favorite: true,

                voucher: null,
                payer: payer,
                payer_code: null
            }
            this.$validator.reset();
        }
    }
}
</script>

<style scoped>
.loading-indicator {
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
}

.validation-success,
.validation-failure,
.validation-pending {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, .8);
    text-align: center;
    font-weight: bold;
    font-size: 1.4rem;
    padding: 10px;
    border-radius: 12px;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
}

.validation-success {
    color: #28a745;
}

.validation-pending {
    color: #ff7900;
}

.validation-failure {
    color: #dd1717;
}

.validation-success img,
.validation-failure img,
.validation-pending img {
    width: 100%;
    height: 132px;
    padding-bottom: 12px;
}

.border-1 {
    border: 1px solid;
}

.border-bottom-1 {
    border-bottom: 1px solid;
}
</style>
